import { useMutation, useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { FetchResult } from 'type/apiType';
import { BatchJobResponse } from 'src/domain/video/asset-source/type/videoSourceType';
import {
  ingestVietnamUpload,
  listVietnamUploads,
  VietnamUploadItem,
  VietnamUploadListParams,
} from 'service/api/vietnamUploadService';

export const VIETNAM_UPLOADS_QUERY_KEYS = {
  all: ['vietnam-uploads'] as const,
  lists: () => [...VIETNAM_UPLOADS_QUERY_KEYS.all, 'list'] as const,
  list: (params?: VietnamUploadListParams) =>
    [...VIETNAM_UPLOADS_QUERY_KEYS.lists(), params ?? {}] as const,
};

export const useVietnamUploads = (
  params?: VietnamUploadListParams,
  options?: Omit<UseQueryOptions<FetchResult<VietnamUploadItem>>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: VIETNAM_UPLOADS_QUERY_KEYS.list(params),
    queryFn: () => listVietnamUploads(params),
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useIngestVietnamUpload = () => {
  const queryClient = useQueryClient();
  return useMutation<BatchJobResponse, unknown, number>({
    mutationFn: uploadId => ingestVietnamUpload(uploadId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: VIETNAM_UPLOADS_QUERY_KEYS.all });
    },
  });
};
